import { EMPTY, BLACK, WHITE, DIRECTIONS, OPPONENT } from './constants'

export function createBoard(size) {
  const board = Array.from({ length: size }, () => Array(size).fill(EMPTY))
  const mid = Math.floor(size / 2)
  board[mid - 1][mid - 1] = WHITE
  board[mid - 1][mid] = BLACK
  board[mid][mid - 1] = BLACK
  board[mid][mid] = WHITE
  return board
}

export function cloneBoard(board) {
  return board.map((row) => row.slice())
}

export function inBounds(size, row, col) {
  return row >= 0 && row < size && col >= 0 && col < size
}

/** 从 (row,col) 沿方向能否翻转；返回可翻转棋子数，0 表示不能下 */
export function flipsInDirection(board, size, row, col, dr, dc, player) {
  const opp = OPPONENT[player]
  let r = row + dr
  let c = col + dc
  let count = 0
  while (inBounds(size, r, c) && board[r][c] === opp) {
    count++
    r += dr
    c += dc
  }
  if (count > 0 && inBounds(size, r, c) && board[r][c] === player) {
    return count
  }
  return 0
}

export function isLegalMove(board, size, row, col, player) {
  if (!inBounds(size, row, col) || board[row][col] !== EMPTY) return false
  for (const [dr, dc] of DIRECTIONS) {
    if (flipsInDirection(board, size, row, col, dr, dc, player) > 0) {
      return true
    }
  }
  return false
}

export function getLegalMoves(board, size, player) {
  const moves = []
  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      if (isLegalMove(board, size, r, c, player)) {
        moves.push([r, c])
      }
    }
  }
  return moves
}

export function applyMove(board, size, row, col, player) {
  const next = cloneBoard(board)
  next[row][col] = player
  for (const [dr, dc] of DIRECTIONS) {
    const n = flipsInDirection(board, size, row, col, dr, dc, player)
    if (n > 0) {
      let r = row + dr
      let c = col + dc
      for (let i = 0; i < n; i++) {
        next[r][c] = player
        r += dr
        c += dc
      }
    }
  }
  return next
}

export function countPieces(board, size) {
  let black = 0
  let white = 0
  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      if (board[r][c] === BLACK) black++
      else if (board[r][c] === WHITE) white++
    }
  }
  return { black, white }
}

export function hasAnyLegalMove(board, size, player) {
  return getLegalMoves(board, size, player).length > 0
}

export function getCornerMask(size) {
  const mask = Array.from({ length: size }, () => Array(size).fill(0))
  const corners = [
    [0, 0],
    [0, size - 1],
    [size - 1, 0],
    [size - 1, size - 1],
  ]
  for (const [r, c] of corners) mask[r][c] = 1
  return mask
}

export function getXSquareMask(size) {
  const mask = Array.from({ length: size }, () => Array(size).fill(0))
  if (size < 4) return mask
  const xs = [
    [1, 1],
    [1, size - 2],
    [size - 2, 1],
    [size - 2, size - 2],
  ]
  for (const [r, c] of xs) mask[r][c] = 1
  return mask
}

export function getCSquareMask(size) {
  const mask = Array.from({ length: size }, () => Array(size).fill(0))
  if (size < 4) return mask
  const cs = [
    [0, 1],
    [1, 0],
    [0, size - 2],
    [1, size - 1],
    [size - 2, 0],
    [size - 1, 1],
    [size - 2, size - 1],
    [size - 1, size - 2],
  ]
  for (const [r, c] of cs) if (inBounds(size, r, c)) mask[r][c] = 1
  return mask
}